import React, { useState, useContext, useCallback, useEffect, useRef } from 'react';
import { Context } from '../../../Context/AuthContext'
import $ from 'jquery';
import { Button, Modal } from "react-bootstrap";
import { Request } from '../../../scripts/Request';
import { Currency } from '../../../scripts/StringUtils';
import InfiniteScroll from "react-infinite-scroll-component";
import { UploadService } from '../../../scripts/UploadService';
import { useNavigate } from 'react-router-dom';
import './Lista.css';



export const Lista = () => {
    const { user, loading, authenticated, handleLogin, handleLogout } = useContext(Context);
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState({ word: "", categoria_id: "", destaque: "" });
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [categorias, setCategorias] = useState([]);
    const navigate = useNavigate();

    const listRef = useRef();
    const pageRef = useRef();
    const totalRef = useRef();
    const categoriasRef = useRef();
    const usersPrestineRef = useRef(false);
    const hiddenFileInput = useRef(null);

    //#region Effects
    useEffect(() => {
        if(user.token !== "" && !usersPrestineRef.current){
            Init();
        }
    }, [user]);


    useEffect(() => {
        if(isLoading){
            window.w_loadObj("body");
        } else {
            window.w_unloadAll();
        }
     }, [isLoading]);
    //#endregion Effects


    //#region Loaders
    const Init = async() => {
        if(!usersPrestineRef.current){
            usersPrestineRef.current = true;
            LoadCategorias();
        }
    }


    const LoadCategorias = () => {
        Promise.resolve(new Request().Run("api/Produtos/Categorias", "POST", { }, user.token, 10*1000))
        .then((data) => {
            categoriasRef.current = data;
            setCategorias(data);
            _HandlerSearchChange(null);
        }).catch(() => {

        })
    }
    //#endregion Loaders


    //#region Handlers
    const _HandlerChange = (event) => {
        let _search = Object.assign({}, search);
        _search[event.target.id] = event.target.value;
        setSearch(_search);
    }


    const _HandlerSearchChange = (event) => {
        setPage(0);
        setOffset(0);
        pageRef.current = { page: 0, offset: 0 };

        listRef.current = [];
        setList(listRef.current);
        setIsLoading(true);
        setHasMore(true);

        Promise.resolve(new Request().Run("api/Produtos/List?page=" + pageRef.current.page + "&interval=50&offset=" + pageRef.current.offset, "POST", { word: search.word, categoria_id: search.categoria_id, destaque: search.destaque}, user.token))
            .then((data) => {
                setTotal(data.total);
                totalRef.current = data.total;
                let _list = [...data.list];
                let _categorias = [...categoriasRef.current];
                _list.map((item, i) => {
                    try {
                        item.categoria = _categorias.find(n => n.id === item.categoria_id).name;
                    } catch (e) {
                        item.categoria = item.categoria === 0 ? "Sem categoria" : "Sem categoria";
                    }
                });
                listRef.current = listRef.current.concat(_list);
                setList(listRef.current);
                setIsLoading(false);
                if (listRef.current.length >= totalRef.current) {
                    setHasMore(false);
                } 
            });
    }


    const _fetchMoreData = () => {
        try {
            if (listRef.current.length >= totalRef.current) {
                setHasMore(false);
                return;
            }

            pageRef.current.page++;
            pageRef.current.offset++;
            setPage(pageRef.current.page);
            setOffset(pageRef.current.offset);
            setIsLoading(true);

            Promise.resolve(new Request().Run("api/Produtos/List?page=" + pageRef.current.page + "&interval=50&offset=" + pageRef.current.offset, "POST", { word: search.word, categoria_id: search.categoria_id, destaque: search.destaque }, user.token))
                .then((data) => {
                    let _list = [...data.list];
                    let _categorias = [...categoriasRef.current];
                    _list.map((item, i) => {
                        try {
                            item.categoria = _categorias.find(n => n.id === item.categoria_id).name;
                        } catch (e) {
                            item.categoria = item.categoria === 0 ? "Sem categoria" : "Sem categoria";
                        }
                    });
                    listRef.current = listRef.current.concat(_list);
                    setList(listRef.current);
                    setIsLoading(false);
                });
        } catch (e) { }
    }


    const _UserClick = (item) => {
        navigate('/Produtos/Cadastro/'+item.produto_id);
    }


    const _DisableUser = async(item) => {
        window.swal({
            title: "Tem certeza?",
            text: "Deseja realmente " + (item.ativo===0?'ativar':'desativar') +" esse produto?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Sim, tenho certeza!',
            cancelButtonText: "Não, cancelar!",
            closeOnConfirm: true,
            closeOnCancel: true
         },
         function(isConfirm){
            if (isConfirm){
                setIsLoading(true);
                Promise.resolve(new Request().Run("api/Produtos/Ativo", "POST", { produto_id: item.produto_id, ativo: (item.ativo===0?1:0) }, user.token))
                        .then((data) => {
                            _HandlerSearchChange();
                            setIsLoading(false);
                        }).catch(()=> {
                            setIsLoading(false);
                        });
            } else {
               
            }
         });

        
    }



    const UploadXls = async(event) => {
        setIsLoading(true);
        const fileUploaded = event.target.files[0];
        let upload = new UploadService();
        upload.OnEnd = (result) => {
            setIsLoading(false);
            LoadCategorias();
        }
        await upload.Upload(fileUploaded, "https://painel.comercialwn.com.br/api/Produtos/UploadXls", user.token);
    }


    const _handlerUploadClick = () => {
        hiddenFileInput.current.click();
    }

    const handleChange = event => {
        UploadXls(event);
    }


    const _HandleCheck = (event, produto) => {
        //console.log(event, banner);

        let _list = [...list];
        let _item = _list.find(item => item.produto_id===produto.produto_id)
        _item.destaque = _item.destaque === 1 ? 0 : 1;

        Promise.resolve(new Request().Run("api/Produtos/Destaque", "POST", { produto_id: produto.produto_id, destaque: _item.destaque}, user.token))
        .then((data) => {
           
        });
        setList(_list);
    }
    //#endregion Handlers

    return (
        <div className="ProdutosLista">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>Lista de Produtos</h5>
                            <span className='pull-right'>
                            <label className="label label-default btn" style={{cursor:'pointer'}} onClick={_handlerUploadClick}> Upload Xls </label>
                            <input type="file" ref={hiddenFileInput} onChange={handleChange} style={{display: 'none'}} accept=".xls,.xlsx"/>
                            <label className="label label-info btn"> { total } produtos </label>
                            </span>
                        </div>

                        <div className="ibox-content">
                            <div className="input-group">
                                <input type="text" id="word" placeholder="Buscar por nome ou código" value={search.word} className="input form-control" onChange={_HandlerChange} />

        
                                <span className="input-group-btn">
                                    <select id="categoria_id" className="input form-control" value={search.categoria_id} onChange={_HandlerChange}>
                                        <option value="">Qualquer categoria</option>
                                        {
                                            categorias.length > 0 ? 
                                            categorias.map((item, i) => (
                                                <option key={'box' + i} value={item.id}>{item.name}</option>
                                            )) : (<></>)
                                        }
                                    </select>
                                </span>

                                <span className="input-group-btn">
                                    <select id="destaque" className="input form-control" value={search.destaque} onChange={_HandlerChange}>
                                        <option value="">Todos</option>
                                        <option value="1">Apenas em destaque</option>
                                        <option value="2">Sem fotos</option>
                                    </select>
                                </span>


                                <span className="input-group-btn">
                                    <button id="btnBusca" type="button" className="btn btn btn-primary" onClick={_HandlerSearchChange}> <i className="fa fa-search"></i> Busca</button>
                                </span>
                            </div>

                            <div>
                                <InfiniteScroll
                                    dataLength={list.length}
                                    next={_fetchMoreData}
                                    hasMore={hasMore}
                                    loader={
                                        <p style={{ textAlign: "center" }}>
                                            <b>Carregando...</b>
                                        </p>
                                    }
                                    style={{ display: 'flex', overflow: 'hidden', flexDirection: 'column' }}
                                    endMessage={
                                        <p style={{ textAlign: "center" }}>
                                            <b>Não há mais dados</b>
                                        </p>
                                    }>


                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Codigo</th>
                                                <th>Nome</th>
                                                <th>Categoria</th>
                                                <th>Preço</th>
                                                <th>Un</th>
                                                <th>Fabricante</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((item, i) => (
                                                <tr key={'user' + i} className={(item.ativo===1?'':'risk')}>
                                                    <td><input type="checkbox" className="checkbox" checked={item.destaque===1} onClick={(event) => _HandleCheck(event, item)} /></td>
                                                    <td onClick={() => _UserClick(item)}> {item.codigo} </td>
                                                    <td onClick={() => _UserClick(item)}> {item.descricao} <i className={'fa fa-check ' + (item.hasfotos===1?'':'hide')} style={{color:'#23c6c8'}}></i> </td>
                                                    <td onClick={() => _UserClick(item)}> {item.categoria} </td>
                                                    <td onClick={() => _UserClick(item)}> {Currency(item.preco)} </td>
                                                    <td onClick={() => _UserClick(item)}> {item.un} </td>
                                                    <td onClick={() => _UserClick(item)}> {item.fabricante} </td>
                                                    <td style={{ padding: '4px', margin: 0, width: '35px' }}><button className="btn btn-white btn-sm" type="button" onClick={() => _DisableUser(item)} style={{ margin: '1px', padding: '1px', paddingLeft: '7px', paddingRight: '7px' }}><i className={'fa ' + (item.ativo===1?'fa-trash':'fa-user') }></i></button></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </InfiniteScroll>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
}